import { contracts } from '../../data/contracts'

export default {
	name: 'DIAMOND',
	shortName: 'DMND',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].rewardAddress,
	url: 'http://lorem.com',
	logo: 'tokens/OFood.png'
}
